module.exports = __webpack_public_path__ + "img/008-doctor.05122e46.png";